import { create } from "zustand";
import { persist } from "zustand/middleware";

import { Theme } from "../../session/types";

interface ThemeState {
  theme: Theme;
  setTheme: (user: Theme) => void;
}

export const useThemeStore = create(
  persist<ThemeState>(
    (set) => ({
      theme: Theme.Light,
      setTheme: (theme: Theme) => set({ theme: theme }),
    }),
    {
      name: "theme-store",
      onRehydrateStorage: () => (_, error) => {
        if (error) {
          console.error("Ошибка при восстановлении состояния:", error);
        }
      },
    },
  ),
);

interface TieAccountsState {
  allSelected: boolean;
  setAllSelected: (value: boolean) => void;
}

export const useTieAccountsStore = create(
  persist<TieAccountsState>(
    (set) => ({
      allSelected: false,
      setAllSelected: (value: boolean) => set({ allSelected: value }),
    }),
    {
      name: "kostyl-store",
      onRehydrateStorage: () => (_, error) => {
        if (error) {
          console.error("Ошибка при восстановлении состояния:", error);
        }
      },
    },
  ),
);
